// Helpers for building public share links for a publication.
//
// Share links must point at the production canonical origin: a link pasted into
// LinkedIn or Facebook has to resolve for anyone, so we never use the current
// (possibly dev/preview) host. The rich preview card that renders for these
// links is produced separately by the per-publication Open Graph prerender (T-129).

/** Production canonical origin for public publication pages. */
export const CANONICAL_BASE = 'https://agrolense.com'

/** Canonical public URL for a publication, e.g. https://agrolense.com/news/42 */
export function publicationUrl(id: number | string): string {
  return `${CANONICAL_BASE}/news/${id}`
}

/** LinkedIn share-intent URL (no SDK, no credentials). */
export function linkedinShareUrl(url: string): string {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
}

/** Facebook share-intent URL (no SDK, no credentials). */
export function facebookShareUrl(url: string): string {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
}
